import TuneIcon from "@mui/icons-material/Tune";

import { MASTER_CONFIGS } from "./masterdata_master_data/configs";
import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "masterdata", spoke: "masterdata", title: "Master data", icon: TuneIcon, order: 800, entries: [
  { label: "Company profile", to: "/app/masterdata/company", permission: "masterdata.company_profile.view" },
  ...MASTER_CONFIGS.map((c) => ({ label: c.title, to: `/app/masterdata/${c.key}`, permission: `${c.permission}.view` })),
] });
